// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"70078555","977":"f0103475"}[chunkId] + ".chunk.js";
};